/**
 * ArbolApiClient -- el arbol de un proyecto como grafo (ARBOL-GRAFO-VISTA-T1, Ares #42417/#42418).
 *
 * Contrato propuesto a A (#42427, ARBOL-GRAFO-DATOS-T1): GET /api/v1/arbol/{projectKey} ->
 *   data: { proyecto, grupos[], nodos[], aristas[], recorridos[], endpoints[] } (solo lectura, sin datos de negocios).
 * Servido en la API 1.6.1009 (nexo-api 776, A #42809); el ejemplo de mientras tanto se retiro. Un 404 hoy es una API
 * vieja (NO_PUBLICADO) y la vista lo dice sin pintar nada inventado. Nunca lanza.
 *
 * @module infrastructure/api/ArbolApiClient
 */
import { ApiBase } from './ApiBase.js';

function motivo(res) {
  if (res?.code === 404) return 'NO_PUBLICADO';
  if (res?.code === 401 || res?.code === 403) return 'PROHIBIDO';
  if (res?.code === 'NETWORK' || res?.code === 'TIMEOUT') return 'SIN_RED';
  return 'ERROR_API';
}

export const ArbolApiClient = {
  async leer(projectKey) {
    let res;
    try {
      res = await ApiBase.get(`/api/v1/arbol/${encodeURIComponent(String(projectKey ?? ''))}`);
    } catch {
      return { ok: false, motivo: 'SIN_RED' };
    }
    if (!res?.ok) return { ok: false, motivo: motivo(res) };
    return { ok: true, data: res.data?.data ?? res.data ?? null };
  }
};
